<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import EmployeeOptionalForm from '@/components/employee-optionals/EmployeeOptionalForm.vue';
    import { EmployeeOptional } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        employeeOptional: EmployeeOptional;
    }>();

    const { id, name, ...fillable } = props.employeeOptional;

    const form = useForm({
        ...fillable,
    });
</script>

<template>
    <DialogForm
        type="update"
        method="post"
        :form="form"
        :route="route('v2.salary.employees-optionals.update', { companyId: employeeOptional.id })"
        :query-key="[QueryKey.EMPLOYEE_OPTIONALS]"
        title="employees-optionals.page_header"
        submit-text="forms.save"
        hide-success-toast
        @success="
            () => {
                toast.success(t('forms.general.success'), {
                    description: t('employees-optionals.success', {
                        company_name: employeeOptional.name,
                    }),
                });
            }
        "
    >
        <EmployeeOptionalForm :form="form" />
    </DialogForm>
</template>
